module.exports = {
	"amp": "&",
	"apos": "'",
	"gt": ">",
	"lt": "<",
	"quot": "\""
};


//////////////////
// WEBPACK FOOTER
// ./~/entities/maps/xml.json
// module id = 192
// module chunks = 0